//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import validationMixin from '../mixins/validation';

export default {
    directives: {
        autofocus: {
            inserted(el, binding) {
                if (binding.value) {
                    el.focus();
                }
            },
        },
    },
    mixins: [
        validationMixin,
    ],
    props: {
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: null,
        },
        secondaryLabel: {
            type: String,
            default: null,
        },
        labelledby: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'text',
        },
        autocomplete: {
            type: [String, Boolean],
            default: false,
        },
        autocorrect: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: {
            type: [Boolean, String],
            default: false,
        },
        success: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isClient: {
            type: Boolean,
            default: false,
        },
        margins: {
            type: Boolean,
            default: true,
        },
        maxlength: {
            type: String,
            default: '524288',
        },
        minlength: {
            type: String,
            default: null,
        },
        enterkeyhint: {
            type: String,
            default: null,
            validator(value) {
                return ['enter', 'done', 'go', 'next', 'previous', 'search', 'send'].indexOf(value) !== -1;
            },
        },
        inputref: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            inputText: '',
        };
    },
    computed: {
        /** @return {string} */
        autocompleteValue() {
            if (typeof this.autocomplete === 'boolean' && this.autocomplete) {
                return 'on';
            } else if (typeof this.autocomplete === 'string' && this.autocomplete) {
                return this.autocomplete;
            }
            return 'off';
        },
        /** @return {string} */
        primaryLabel() {
            if (this.validationError) {
                return this.validationError;
            }

            return typeof this.error === 'string' && this.error.length ? this.error : this.label || this.placeholder;
        },
        /** @return {boolean} */
        hasError() {
            return !!this.validationError || !!(this.error && this.error.length);
        },
    },
    watch: {
        value(value) {
            this.inputText = value;
        },
    },
    created() {
        this.inputText = this.value;
    },
    methods: {
        /** @param {Event} e */
        change(e) {
            const target = /** @type {HTMLInputElement} */(e.target);
            const value = this.type === 'file' ? target.files : target.value;
            /**
             * @event change
             * @property {string} value
             */
            this.$emit('change', value);
        },
        /** @param {InputEvent} e */
        input(e) {
            const target = /** @type {HTMLInputElement} */(e.target);
            const value = target.value;
            this.inputText = value;
            this.validationInputHandler(value);
            /**
             * @event input
             * @property {string} value
             * @property {InputEvent} e
             */
            this.$emit('input', value, e);
        },
        blur() {
            this.validationBlurHandler();
            this.$emit('blur');
        },
        focus() {
            this.$emit('focus');
        },
        /** @param {KeyboardEvent} e */
        keydown(e) {
            /**
             * @event keydown
             * @property {KeyboardEvent} e
             */
            this.$emit('keydown', e);
        },
        /** @param {KeyboardEvent} e */
        keypress(e) {
            /**
             * @event keypress
             * @property {KeyboardEvent} e
             */
            this.$emit('keypress', e);
        },
        keyupEnter() {
            this.$emit('keyup-enter');
        },
    },
};
